import {LinearProgress, Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../../../../../i18n/translations';
import {PlannerActivityItem} from '../planner-item';
import {PlannerListAvatars, PlannerListRow, plannerListTextSx} from './planner-list-row';

type PlannerListActivityItemProps = {
  item: PlannerActivityItem;
  selected?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
};

export function PlannerListActivityItem({item, ...props}: PlannerListActivityItemProps) {
  const {t} = useTranslation();

  return (
    <PlannerListRow onClick={props.onClick} selected={props.selected}>
      {/* ------------ HOUR ------------ */}
      <Typography
        sx={{
          ...plannerListTextSx,
          flex: 0.5,
          marginRight: '23px',
        }}
      >
        {item.date.format.hour}
      </Typography>

      {/* ------------ ACTIVITY GROUP ------------ */}
      <Typography
        sx={{
          ...plannerListTextSx,
          marginRight: '15px',
          flex: 2,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textWrap: 'nowrap',
        }}
      >
        {item.activitiesGroup.name}
      </Typography>

      {/* ------------ ACTIVITY TYPE ------------ */}
      <Typography
        sx={{
          ...plannerListTextSx,
          flex: 2,
          marginRight: '15px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textWrap: 'nowrap',
        }}
      >
        {item.activitiesType.name}
      </Typography>

      {/* ------------ AVATARS ------------ */}
      <PlannerListAvatars users={item.users} />

      {/* ------------ TASK COMPLETION ------------ */}
      {/* ------ PROGRESS BAR ------ */}
      <Stack alignItems="center" flexDirection="row" gap="8px" flex="1" marginRight="16px">
        <LinearProgress
          variant="determinate"
          value={(100 * item.info.handled) / item.info.total}
          sx={{
            flex: 1,
            height: '9px',
            backgroundColor: 'gray.bg',
            borderRadius: '5px',
          }}
        />
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '16px',
            color: item.info.total === item.info.handled ? 'primary.main' : 'gray.main',
          }}
        >
          {`${item.info.handled}/${item.info.total}`}
        </Typography>
      </Stack>

      {/* ------ UNTREATED INDICATION ------ */}
      <Stack alignItems="center" flexDirection="row" minWidth="134px" flex="1">
        {item.info.untreated > 0 && (
          <Stack flexDirection="row" alignContent="center" color="secondary.main" flex="1">
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '16px',
                width: '26px',
                textAlign: 'center',
              }}
            >
              !
            </Typography>
            <Typography
              sx={{
                flex: 1,
                fontWeight: 500,
                fontSize: '16px',
              }}
            >
              {t(translations.planner.body.untreaten, {count: item.info.untreated})}
            </Typography>
          </Stack>
        )}
      </Stack>
    </PlannerListRow>
  );
}
